<template>
  <!--  노션 링크 : https://www.notion.so/StarthousePage-00f054ca15e1413795abea16a9a63d3a -->
  <div>
    <div>
      <breadcrumb :breadcrumb_link="starthouse_breadcrumb" />
    </div>
    <div class="header">
      <h1 class="overlay">START HOUSE</h1>
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="contentDesc">
      <div :class="{jpword: isLang === 2}">
        <div :class="{anotherword: isLang === 0 || isLang === 1}">
          <div class="title1">
            <h2>
              <strong>{{ $t('starthouse_title') }}</strong>
            </h2>
          </div>
          <div class="title2">
            <h4>{{ $t('starthouse_subtitle') }}</h4>
          </div>
          <div class="title3">
            <p>{{ $t('starthouse_desc') }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <GallerySlideCarousels :slides="slides" :slide-count="4" :thumb-slide-width="50" />

      <div :class="{jpword: isLang === 2}">
        <div :class="{anotherword: isLang === 0 || isLang === 1}">
          <div class="container" v-show="isLang === 0">
            <div class="d-flex justify-content-center mt-5 mb-5">
              <h1>SIGNATURE MENU</h1>
            </div>
            <!--      <div class="">-->
            <!--        <Dining v-show="true" :show-signature-mode="true" />-->
            <!--      </div>-->

            <!-- 시그니처메뉴 static으로 수정-->
            <div class="row d-flex justify-content-center">
              <div class="card-deck">
                <div class="card">
                  <img
                    class="card-img-top"
                    src="@/assets/images/Golf/starthouse_signaturemenu_image16.jpg"
                    alt="Card image cap"
                    style="padding: 10px"
                  />
                  <div class="card-body">
                    <h5 class="card-title"><strong>살치 육전과 한치무침</strong></h5>
                    <p class="card-text">살치살 육전과 매콤 새콤한 한치무침을 곁들여 먹는 요리</p>
                  </div>
                </div>
                <div class="card">
                  <img
                    class="card-img-top"
                    src="@/assets/images/Golf/starthouse_signaturemenu_image04.jpg"
                    alt="Card image cap"
                    style="padding: 10px"
                  />
                  <div class="card-body">
                    <h5 class="card-title"><strong>통한치 크림 모닥치기</strong></h5>
                    <p class="card-text">“한 접시에 모아준다”라는 의미를 담은 핀크스만의 로제 떡볶이</p>
                  </div>
                </div>
                <div class="card">
                  <img
                    class="card-img-top"
                    src="@/assets/images/Golf/starthouse_signaturemenu_image15.jpg"
                    alt="Card image cap"
                    style="padding: 10px"
                  />
                  <div class="card-body">
                    <h5 class="card-title"><strong>전복 해물 자장면</strong></h5>
                    <p class="card-text">신선한 전복이 들어간 핀크스만의 대표적인 자장면</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <table class="table table-borderless mt-5 mb-5">
        <tbody>
          <tr>
            <td width="25%">{{ $t('starthouse_table_td1') }}</td>
            <td>{{ $t('starthouse_table_td2') }}</td>
          </tr>
          <tr>
            <td>{{ $t('starthouse_table_td9') }}</td>
            <td>
              <a target="_blank" href="/files/pdf/starthouse_menu.pdf" class="res-button">{{
                $t('starthouse_table_td10')
              }}</a>
            </td>
          </tr>
          <tr>
            <td>{{ $t('starthouse_table_td5') }}</td>
            <td>{{ $t('starthouse_table_td6') }}</td>
          </tr>
          <tr>
            <td>{{ $t('starthouse_table_td7') }}</td>
            <td>{{ $t('starthouse_table_td8') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import GallerySlideCarousels from '@/components/GallerySlideCarousels';
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'StarthousePage',
  data() {
    return {
      starthouse_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'DINING',
        present: this.$t('breadcrumb'),
      },
      slides: [
        {image: require('@/assets/images/Golf/starthouse_bodyimage01.jpg')},
        {image: require('@/assets/images/Golf/starthouse_bodyimage02.jpg')},
        {image: require('@/assets/images/Golf/starthouse_bodyimage03.jpg')},
        {image: require('@/assets/images/Golf/starthouse_bodyimage04.jpg')},
        {image: require('@/assets/images/Golf/starthouse_bodyimage05.jpg')},
      ],
      index: 0, // default: 0,
      isLang: 0,
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.starthouse_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'DINING',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  components: {
    GallerySlideCarousels,
    Breadcrumb,
  },
};
</script>

<style scoped lang="scss">
.card-body > p {
  padding: 0rem;
}
.jpword {
  word-break: break-all;
}
.anotherword {
  p,
  h1,
  h2,
  h3,
  h4,
  h5 {
    word-break: keep-all;
  }
}

.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}

.contentDesc {
  text-align: center;

  .title1 {
    margin-top: 3rem;
  }

  .title2 {
    margin-top: 3rem;
  }

  .title3 {
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
}
.Banquethall_breadcrumb {
  margin-top: 130px;
}

.Banquethall_body_hedaer {
  margin-top: 40px;
  margin-bottom: 50px;
}

.overlay {
  color: White;
  position: absolute;
  z-index: 12;
  top: 30%;
  left: 0;
  width: 100%;
  text-align: center;
}
td {
  border-bottom: 1px dashed #cdcdcd;
}
.res-button {
  position: relative;
  display: inline-block;
  padding: 4px 22px;
  font-size: 15px;
  background-color: #524a3d;
  color: #fff;
  margin-right: 5px;
}
@media (max-width: 992px) {
  .card-deck {
    display: -ms-flexbox;
    display: block;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    margin-right: 15px;
    margin-bottom: 15px;
    margin-left: 15px;
  }

  .main-ex-img {
    margin-bottom: 50px;
  }
  .main-ex-desc {
    vertical-align: center;
    text-align: center;
  }
  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }

  h4 {
    font-size: 1.2rem !important;
    font-weight: 600;
    padding: 0 1rem;
  }

  h3 {
    font-size: 1.2rem !important;
    font-weight: 600;
  }
  p {
    font-size: 0.9rem !important;
    padding: 0 1rem;
  }

  div {
    font-size: 0.9rem !important;
  }
}

@media (min-width: 992px) {
  .main-ex-desc {
    vertical-align: bottom;
  }
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/Golf/starthouse_headerimage.jpg');
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "스타트 하우스",
    "starthouse_title": "스타트 하우스",
    "starthouse_subtitle": "플레이 중 간단한 식사와 담소를 즐길 수 있는 휴식과 여유의 공간",
    "starthouse_desc": "눈 앞에 펼쳐지는 WEST 1번홀과 산방산을 바라보며 라운딩 전 여유로움을 느낄 수 있는 공간으로, 간단한 식사와 시원한 음료가 준비되어 있습니다.",

    "starthouse_table_td1": "위치",
    "starthouse_table_td2": "West 1홀",
    "starthouse_table_td3": "운영시간",
    "starthouse_table_td4": "09:00 ~ 16:30",
    "starthouse_table_td9": "메뉴",
    "starthouse_table_td10": "메뉴보기",
    "starthouse_table_td5": "규모",
    "starthouse_table_td6": "실내 24석",
    "starthouse_table_td7": "문의",
    "starthouse_table_td8": "064-793-5035"
  },

  "en":{
    "breadcrumb": "START HOUSE",
    "starthouse_title": "START HOUSE",
    "starthouse_subtitle": "The Space for resting and relaxation where you can enjoy simple meals and chatting while playing.",
    "starthouse_desc": "It is the space to feel the leisure before a round with the view of the West hole 1 and Sanbangsan mountain spreading before your eyes. Simple meals and refreshing drinks are available.",

    "starthouse_table_td1": "Location",
    "starthouse_table_td2": "West 1Hole",
    "starthouse_table_td3": "Opening Hours",
    "starthouse_table_td4": "09:00 ~ 16:30",
    "starthouse_table_td9": "MENU",
    "starthouse_table_td10": "Menu",
    "starthouse_table_td5": "Size",
    "starthouse_table_td6": "24 seats, indoors",
    "starthouse_table_td7": "Reservation & Inquiry",
    "starthouse_table_td8": "+82-64-793-5035"
  },

  "ja": {
    "breadcrumb": "スタートハウス",
    "starthouse_title": "スタートハウス",
    "starthouse_subtitle": "プレー中に簡単な食事や談笑を楽しむことのできる休息とゆとりのスペース",
    "starthouse_desc": "目の前に広がるWest 1番ホールと山房山を眺め、プレー前の余裕のひと時を過ごすスペースで、軽食や冷たい飲み物が準備されています。",

    "starthouse_table_td1": "位置",
    "starthouse_table_td2": "西の1ホール スタートハウス",
    "starthouse_table_td3": "営業時間",
    "starthouse_table_td4": "09:00 ~ 16:30",
    "starthouse_table_td9": "MENU",
    "starthouse_table_td10": "Menu",
    "starthouse_table_td5": "規模",
    "starthouse_table_td6": "室内24席",
    "starthouse_table_td7": "お問い合せ",
    "starthouse_table_td8": "+82-64-793-5035"
  }
}
</i18n>
